import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  Chip,
  Box,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/core/styles";


const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: 600,
    textAlign: "center"
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1)
  },
  chip: {
    marginRight: 6,
    color: "#fff",
    fontWeight: 600
  },
  areaBox: {
    padding: "6px 10px",
    background: "#f5f5f5",
    borderRadius: 6,
    marginBottom: 6
  },
}));

export default function ModalEvent({ open, onClose, event }) {
  const classes = useStyles();

  if (!event) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      {/* TITLE */}
      <DialogTitle disableTypography style={{ position: "relative" }}>
        <Typography variant="h6" className={classes.title}>
          {event.event_name}
        </Typography>

        <IconButton className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* CONTENT */}
      <DialogContent dividers>
        {/* Event Type */}
        <Typography variant="body1">
          <b>ประเภทเหตุการณ์:</b> {event.event_type || "-"}
        </Typography>

        {/* Start / End Date */}
        <Typography variant="body1">
          <b>วันที่เริ่มต้น:</b> {event.start_date}
        </Typography>

        <Typography variant="body1">
          <b>วันที่สิ้นสุด:</b> {event.end_date}
        </Typography>

        {/* Status */}
        <Typography variant="body1" style={{ marginTop: 10 }}>
          <b>สถานะ:</b> {event.status_name.name ?? ''}
        </Typography>

        {/* Description */}
        <Box mt={2}>
          <Typography variant="subtitle1"><b>รายละเอียด:</b></Typography>
          <div
            style={{ marginTop: 8 }}
            dangerouslySetInnerHTML={{
              __html: event.description || "<i>ไม่มีข้อมูล</i>"
            }}
          />
        </Box>

        {/* TAGS */}
        <Box mt={3}>
          <Typography variant="h6">แท็กที่เกี่ยวข้อง</Typography>

          {(event.tags || []).map((tag) => (
            <Chip
              key={tag.id}
              label={tag.name}
              className={classes.chip}
              style={{ backgroundColor: tag.color }}
            />
          ))}
        </Box>

        {/* AREAS */}
        <Box mt={3}>
          <Typography variant="h6">
            พื้นที่ที่ได้รับผลกระทบ ({event.areas?.length || 0})
          </Typography>

          {(event.areas || []).map((area) => (
            <div key={area.id} className={classes.areaBox}>
              <Typography variant="body2">
                {area.label}
              </Typography>
            </div>
          ))}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
